import { AuthenticateWithRedirectCallback } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";

/**
 * FlirtMachine admin OAuth (SSO) return route — completes the Clerk
 * social-login round-trip for `<SignIn routing="path" path="/admin/login">` at
 * `/flirtmachine/admin/login`. Lives outside `_authenticated` so it stays a
 * public path (the OAuth round-trip happens before the session is established).
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/flirtmachine/admin/login/sso-callback")({
  component: FlirtMachineAdminSSOCallback,
});

export function FlirtMachineAdminSSOCallback() {
  return <AuthenticateWithRedirectCallback />;
}
